import Component from 'vue-class-component';
import {Mixins, Prop} from 'vue-property-decorator';
import EdCourse from '../ed-course/ed-course.vue';
import EdHomeworkFeedback from '../../../../../homework/component/ed-homework-feedback/ed-homework-feedback.vue';
import {EVENT_BUS} from '@/content/values/events';
import {SECTION_TYPES} from '@/content/values/sections';
import { STORE } from '@/core/store/core.store';
import { WidgetStudentCourse } from '@/homework/models/widget-student-course.model';
import { HOMEWORKS_EVENTS, HOMEWORKS_API } from '@/homework/values/homeworks.values';
import { ContainerUsersMixin } from '@/mixins/common/container-users.mixin';
import { SCREEN_MIRRORING_EVENTS } from '@/values/screen.mirroring.values';
import { SERVER_HOSTNAME } from '@/shared/enums/request.enum';

@Component({
  components: {
    EdCourse,
    EdHomeworkFeedback
  }
})
export default class EdCourses extends Mixins(ContainerUsersMixin) {
  
  /* Arguments */
  @Prop() readonly options: any; 
  @Prop() readonly createMeeting: any;

  /* Data */
  public isLoadingCourses: boolean = false;
  public myComponentResponse: any = null;
  public currentCourse: any = null;
  public currentHomework: any = null;
  public paramsReponse : any = { title : '' }

  /* Computed */
  get courses(): WidgetStudentCourse[] { 
    return this.$store.state.HomeworksStore.studentWidgetHomeworks.courses
  }

  /* Method */
  public loadMoreCourses(): void {
    this.getCourses();
  }

  public async getCourses(): Promise<any> {
    this.isLoadingCourses = true;
    await this.$store.dispatch(
      STORE.HOMEWORKS.ACTIONS.GET_COURSES_HOMEWORKS_BY_STUDENT,
      {refresh:true}
    ).finally(() => {
      this.isLoadingCourses = false;
    });
  }

  public sendResponse({ homework, course }: any): void{
    this.currentHomework = homework;
    this.currentCourse = course;
    this.myComponentResponse = 'ed-homework-feedback';
  }

  public onSaveResponse(option: any) {
    let params = this.getParamsBaseToResponse(option);
    let modal = option.modalHomework ? option.modalHomework : option.modal;
    this.$EdModal.createModal(modal,  params);
  }

  public onCloseResponse() {
    this.currentHomework = null;
    this.currentCourse = null;
    this.myComponentResponse = null;
  }

  public formatFileFeedback(data: any) {
    return {
      homework: {
        sectionId: this.currentHomework.sectionId,
        name: data.name,
        description: data.description,
        type: data.type,
        classId: this.currentCourse.classId,
        fileUpload: data.fileUpload || false
      },
      isResponse: false
    }
  }

  public getParamsBaseToResponse(data: any): any{
    let params: any = {
      section : {
        name: this.$i18n.t(`common.${data.type}`),
        type: data.code
      },
      courseId: this.currentCourse.id,
      isHomeworkResponse: true,
      canSetHomework: false,
      titleModal : `${this.$i18n.t(`common.${data.type}`)} ${this.$i18n.t('common.response')}`,
      objId: this.$store.state.MyContentStore.userId,
      modalBusSaveEvent: EVENT_BUS.RESPONSE_HOMEWORK_MODAL,
      formatData: this.formatFileFeedback
    }
    if(data.code == SECTION_TYPES.LESSON_TEMP_FILE.code || data.code == SECTION_TYPES.LESSON_IMAGES.code) {
      let dropOptions: any = {
        url: `${process.env[SERVER_HOSTNAME.COMMON]}/${HOMEWORKS_API.CREATE_HOMEWORK}`,
        autoProcessQueue: false,
        acceptedFiles: 'application/pdf,.docx,.doc,.xlsx,.xls',
        addRemoveLinks: false,
        maxFiles: 1,
        paramName: 'homeworkResource',
        parallelUploads: 1,
        createImageThumbnails: false,
        method: 'post'
      }
      if(data.code == SECTION_TYPES.LESSON_IMAGES.code){
        dropOptions.createImageThumbnails = true;
        dropOptions.acceptedFiles= 'image/*';
      } else {
        dropOptions.maxFilesize= 200;
        dropOptions.timeout= 600000;
      }
      params.modalBusSaveEvent= `${EVENT_BUS.RESPONSE_HOMEWORK_MODAL}_FILE_MANUALLY`
      params.dropOptions = dropOptions;
    }
    return params;
  }

  public async saveModal(data: any, params: any) {
    switch (params.section.type) {
      case SECTION_TYPES.LESSON_TEXT.code:
      case SECTION_TYPES.LESSON_EXTERNAL_LINK.code:
      case SECTION_TYPES.LESSON_VIDEO.code:
        if(params.section) {
          if(params.section.type !== null){
            data.type = params.section.type;
          }
        }
        (this.$root.$children[0].$children[0].$refs.EdLoading as any).show();
        this.$store.dispatch(STORE.HOMEWORKS.ACTIONS.SET_STUDENT_HOMEWORK_RESPONSE, { 
          req: {
            sectionId: this.currentHomework.sectionId,
            classId: this.currentCourse.classId,
            name: data.name,
            description: data.description,
            type: data.type,
            text: data.text
          },
          file: null
        }).finally(() => {
          this.homeworkResponseSent({ courseId: this.currentCourse.id, sectionId: this.currentHomework.sectionId });
          this.onCloseResponse();
          this.$EdModal.$emit(`${EVENT_BUS.RESPONSE_HOMEWORK_MODAL}_CLOSE`);
          (this.$root.$children[0].$children[0].$refs.EdLoading as any).hide();
        });
      break;
    }
  }

  public homeworkResponseSent({ courseId, sectionId }: any){
    this.$store.commit(STORE.HOMEWORKS.MUTATIONS.REMOVE_STUDENT_HOMEWORK,{ courseId, sectionId });
  }

  /* Hooks */
  mounted() {
    if(!this.$store.state.MyContentStore.coursesAlreadyLoad) {
      this.getCourses();
      this.$store.commit(STORE.MY_CONTENT.MUTATIONS.SET_COURSES_ALREADY_LOADED, true);
    }
    this.paramsReponse.title = this.$i18n.t('homeworks.addReponse');
  }

  created(){
    this.$edEventBus.$on(EVENT_BUS.RESPONSE_HOMEWORK_MODAL, this.saveModal);
    this.$edEventBus.$on(HOMEWORKS_EVENTS.OPEN_SEND_RESPONSE_HOMEWORK, this.sendResponse)
    this.$edEventBus.$on(SCREEN_MIRRORING_EVENTS.ON_WSSOCKET_RECONNECTION, this.getCourses);
    this.$edEventBus.$on(`${EVENT_BUS.RESPONSE_HOMEWORK_MODAL}_FILE_MANUALLY`, () => {
      this.homeworkResponseSent({ courseId: this.currentCourse.id, sectionId: this.currentHomework.sectionId });
      this.onCloseResponse();
      this.$EdModal.$emit(`${EVENT_BUS.RESPONSE_HOMEWORK_MODAL}_FILE_MANUALLY_CLOSE`);
    });
  }

  beforeDestroy(): void {
    this.$edEventBus.$off(SCREEN_MIRRORING_EVENTS.ON_WSSOCKET_RECONNECTION, this.getCourses);
  }
} 